import { Text } from '@crm/components'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getDuplicateData } from '@crm/utils'
import { useLocales } from '@shared/locales'
import { Alert, Button, Flex } from 'antd'

type Props = {
  error: unknown
  onClose?: () => void
}

export const DuplicateAlert = ({ error, onClose }: Props) => {
  const { t } = useLocales()
  const navigate = useAppNavigate()

  const duplicate = getDuplicateData(error)

  if (!duplicate) {
    return null
  }

  return (
    <Alert
      className="mb-10"
      type="warning"
      showIcon
      closable
      onClose={onClose}
      message={duplicate.detail}
      description={
        <Flex vertical gap={4}>
          {duplicate.items.map((item, index) => (
            <Flex
              key={item.id ?? index}
              align="center"
              justify="space-between"
              gap={8}
            >
              <Text>{item.phoneNumbers.join(', ')}</Text>
              {item.id && (
                <Button
                  type="link"
                  onClick={() => {
                    onClose?.()
                    navigate(paths.leadsDetails.root(item.id as string))
                  }}
                >
                  {t('contacts.view_lead')}
                </Button>
              )}
            </Flex>
          ))}
        </Flex>
      }
    />
  )
}
